// extracted by mini-css-extract-plugin
module.exports = {"table":"modify-members-in-role-modal_table__BtY7c","saveButton":"modify-members-in-role-modal_saveButton__29fDf"};